import { faBuildingColumns } from '@fortawesome/pro-regular-svg-icons/faBuildingColumns';
import { faChartPie } from '@fortawesome/pro-regular-svg-icons/faChartPie';
import { faCompass } from '@fortawesome/pro-regular-svg-icons/faCompass';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';
import { faInboxFull } from '@fortawesome/pro-regular-svg-icons/faInboxFull';
import { faMap } from '@fortawesome/pro-regular-svg-icons/faMap';
import { faPenCircle } from '@fortawesome/pro-regular-svg-icons/faPenCircle';
import { faPerson } from '@fortawesome/pro-regular-svg-icons/faPerson';
import { faSackDollar } from '@fortawesome/pro-regular-svg-icons/faSackDollar';
import { faScrewdriverWrench } from '@fortawesome/pro-regular-svg-icons/faScrewdriverWrench';
import { faSuitcase } from '@fortawesome/pro-regular-svg-icons/faSuitcase';
import { faTemperatureList } from '@fortawesome/pro-regular-svg-icons/faTemperatureList';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faBuildingColumns as faBuildingColumnsSolid } from '@fortawesome/pro-solid-svg-icons/faBuildingColumns';
import { faChartPie as faChartPieSolid } from '@fortawesome/pro-solid-svg-icons/faChartPie';
import { faCompass as faCompassSolid } from '@fortawesome/pro-solid-svg-icons/faCompass';
import { faGlobe as faGlobeSolid } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as faGraduationCapSolid } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as faHandshakeSolid } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faIdCard as faIdCardSolid } from '@fortawesome/pro-solid-svg-icons/faIdCard';
import { faInboxFull as faInboxFullSolid } from '@fortawesome/pro-solid-svg-icons/faInboxFull';
import { faMap as faMapSolid } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faPenCircle as faPenCircleSolid } from '@fortawesome/pro-solid-svg-icons/faPenCircle';
import { faPerson as faPersonSolid } from '@fortawesome/pro-solid-svg-icons/faPerson';
import { faSackDollar as faSackDollarSolid } from '@fortawesome/pro-solid-svg-icons/faSackDollar';
import { faScrewdriverWrench as faScrewdriverWrenchSolid } from '@fortawesome/pro-solid-svg-icons/faScrewdriverWrench';
import { faSuitcase as faSuitcaseSolid } from '@fortawesome/pro-solid-svg-icons/faSuitcase';
import { faTemperatureList as faTemperatureListSolid } from '@fortawesome/pro-solid-svg-icons/faTemperatureList';
import { faUsers as faUsersSolid } from '@fortawesome/pro-solid-svg-icons/faUsers';

import getPublicCourseCatalogURL from 'components/Common/LayoutV2/utils/getPublicCourseCatalogURL';
import { EL_VIRTUAL_TOURS, VIRTUAL_TOURS } from 'routes/constants';
import { conditionalArray } from 'utils/arrays';
import { loginURL as methodTestPrepLoginURL } from 'utils/MethodTestPrep';

const PersonIcon = {
  solid: faPersonSolid,
  regular: faPerson,
};
const ScrewdriverWrenchIcon = {
  solid: faScrewdriverWrenchSolid,
  regular: faScrewdriverWrench,
};
const MapIcon = {
  solid: faMapSolid,
  regular: faMap,
};
const ScholarshipsIcon = {
  solid: faSackDollarSolid,
  regular: faSackDollar,
};
const BuildingColumnsIcon = {
  solid: faBuildingColumnsSolid,
  regular: faBuildingColumns,
};
const CompassIcon = {
  solid: faCompassSolid,
  regular: faCompass,
};
const AlumIcon = {
  solid: faGraduationCapSolid,
  regular: faGraduationCap,
};
const SuitcaseIcon = {
  solid: faSuitcaseSolid,
  regular: faSuitcase,
};
const PenCircleIcon = {
  solid: faPenCircleSolid,
  regular: faPenCircle,
};
const GlobeIcon = {
  solid: faGlobeSolid,
  regular: faGlobe,
};
const HandshakeIcon = {
  solid: faHandshakeSolid,
  regular: faHandshake,
};
const PartnersIcon = {
  solid: faUsersSolid,
  regular: faUsers,
};
const PieChartIcon = {
  solid: faChartPieSolid,
  regular: faChartPie,
};
const TemperatureListIcon = {
  solid: faTemperatureListSolid,
  regular: faTemperatureList,
};
const InboxFullIcon = {
  solid: faInboxFullSolid,
  regular: faInboxFull,
};
const IDCardIcon = {
  solid: faIdCardSolid,
  regular: faIdCard,
};

/* Routes will determine which side nav icon is active. Note that some routes are within different groups based on user type
 * For example, Scholarship Management is under College for Counselors but under Engage for Members. Be mindful of this
 * to prevent two side nav icons from being active at the same time.
 * */
export const MENU_ICON_MAP_ENH = ({
  isElementary,
  user: { isStudent, isCounselor, isMember },
}) => ({
  'side-menu-students': {
    icon: PersonIcon,
    routes: [
      '/student-list',
      '/el/student-list',
      '/meetings',
      ...conditionalArray(!isElementary, ['/checkins']),
      '/badges',
      '/scope-and-sequence-verification',
      '/record-requests',
      '/students',
      '/el/experience-tracking',
      '/el/casefile',
    ],
  },
  'side-menu-plan': {
    icon: MapIcon,
    routes: [
      '/course-plans',
      '/course-planner/',
      '/course-catalog',
      '/student-pathways',
      '/personalized-plans',
      '/el/personalized-plans',
      '/lesson-library',
      '/goals',
      '/plans',
      ...conditionalArray(isStudent, [
        '/key-readiness-indicators/tree',
        '/course-planner',
      ]),
    ],
  },
  'side-menu-scholarships': {
    icon: ScholarshipsIcon,
    routes: [
      ...(isStudent
        ? ['/scholarships', '/college-costs', '/scholarship-matching']
        : []),
      ...(isCounselor
        ? [
            '/scholarships',
            '/scholarship-management',
            '/award-letter-verification',
            '/scholarship-matching',
            '/fafsa-tracker',
          ]
        : []),
    ],
  },
  'side-menu-engage': {
    icon: HandshakeIcon,
    routes: [
      '/events',
      '/opportunities',
      '/opportunity-management',
      '/experience-tracking',
      '/program-exploration',
      '/program-management',
      '/event-scheduler',
      ...conditionalArray(isMember, ['/scholarship-management']),
    ],
  },
  'side-menu-career': {
    icon: SuitcaseIcon,
    routes: [
      '/careers',
      '/employer-showcase',
      '/virtual-tours',
      ...conditionalArray(isCounselor, ['/industry-partner-database']),
      '/initiative-page/texas-semiconductor-manufacturing-careers',
      '/el/career-interest-analytics',
      '/el/industry-partner-database',
      '/el/virtual-tours',
    ],
  },
  'side-menu-college': {
    icon: BuildingColumnsIcon,
    routes: [
      '/schools',
      '/college-applications',
      '/recommendation-letter-portal',
      '/award-letter-verification',
      '/fafsa-tracker',
      '/scholarship-matching',
      ...conditionalArray(isCounselor, ['/scholarship-management']),
      '/enrollment-decision',
      '/college-costs',
    ],
  },
  'side-menu-track': {
    icon: PieChartIcon,
    routes: [
      '/report-center',
      '/el/report-center',
      '/analytics',
      '/senior-survey-analytics',
      '/industry-partner-analytics',
      '/scope-and-sequence-analytics',
      '/el/scope-and-sequence-analytics',
      '/survey-analytics',
      '/el/survey-analytics',
      ...conditionalArray(isCounselor, [
        '/key-readiness-indicators/tree',
        '/key-readiness-indicators/tabular-view',
      ]),
    ],
  },
  'side-menu-alum': {
    icon: AlumIcon,
    routes: ['/alumni'],
  },
  'side-menu-admin': {
    icon: isMember ? IDCardIcon : ScrewdriverWrenchIcon,
    routes: [
      '/rosters',
      '/el/rosters',
      '/survey-bank-management',
      '/college-app-config',
      '/course-planner-setup',
      '/scope-and-sequence-setup',
      '/el/scope-and-sequence-setup',
      '/district-settings',
      '/staff-account-management',
      '/el/staff-account-management',
      '/automation',
      '/data-upload',
      ...conditionalArray(isCounselor, [
        '/key-readiness-indicators/configuration',
      ]),
      '/organization-profile',
      '/community-user-management',
      '/profile-management',
      ...conditionalArray(isMember, ['/industry-partner-database']),
    ],
  },
  'side-menu-student': {
    icon: PersonIcon,
    routes: [
      '/profile',
      '/credential-wallet',
      '/test-scores',
      '/record-requests',
    ],
  },
  'side-menu-explore': {
    icon: CompassIcon,
    routes: ['/assessments', '/learning', '/game-of-life'],
  },
  'side-menu-activities': {
    icon: PenCircleIcon,
    routes: ['/assessments', '/learning'],
  },
  'side-menu-network': {
    icon: PartnersIcon,
    routes: [
      '/industry-partner-events',
      '/industry-partners',
      '/industry-partner-database',
    ],
  },
  'side-menu-checkins': {
    icon: TemperatureListIcon,
    routes: [
      '/el/checkins/schedule',
      '/el/checkins/overview',
      '/el/checkins/insights',
      '/el/checkins/settings',
      '/el/checkins/suggested-lessons',
      '/checkins/overview',
      '/checkins/schedule',
      '/checkins/insights',
      '/checkins/settings',
    ],
  },
  'side-menu-connect': {
    icon: GlobeIcon,
    routes: ['/district-connections'],
  },
  'side-menu-requests': {
    icon: InboxFullIcon,
    routes: [
      '/recommendation-letter-portal',
      '/student-experience-supervision',
    ],
  },
});

export const MENU_ICON_MAP = {
  'side-menu-activities': PenCircleIcon,
  'side-menu-admin': ScrewdriverWrenchIcon,
  'side-menu-plan': MapIcon,
  'side-menu-engage': HandshakeIcon,
  'side-menu-analytics': PieChartIcon,
  'side-menu-elementary-analytics': PieChartIcon,
  'side-menu-career': SuitcaseIcon,
  'side-menu-college': BuildingColumnsIcon,
  'side-menu-network': PartnersIcon,
  'side-menu-alum': AlumIcon,
  'side-menu-checkins': TemperatureListIcon,
  'side-menu-connect': GlobeIcon,
  'side-menu-requests': InboxFullIcon,
  'side-menu-scholarships': ScholarshipsIcon,
};

export const MENU_ICON_LINK_MAP = {
  'side-menu-home': '/login',
};

export const NAV_LINK_MAP = {
  'side-elementary-accountability-system-analytics':
    '/el/scope-and-sequence-analytics',
  'side-accountability-system-analytics': '/scope-and-sequence-analytics',
  'side-accountability-tracker': '/accountability-tracker',
  'side-admin-management': '/staff-account-management',
  'side-admin-management-elementary': '/el/staff-account-management',
  'side-elementary-indicator-accountability-setup':
    '/el/scope-and-sequence-setup',
  'side-alum-analytics': '/alumni/analytics',
  'side-alum-database': '/alumni/database',
  'side-alum-home': '/alumni',
  'side-alum-survey': '/alumni/surveys',
  'side-nsc': '/alumni/national-student-clearinghouse',
  'side-analytics': '/analytics',
  'side-industry-partner-analytics': '/industry-partner-analytics',
  'side-application-manager': '/college-applications',
  'side-enrollment-decision': '/enrollment-decision',
  'side-indicator-requirement-cluster-ncaa': '/college-athletic-eligibility',
  'side-assessments': '/assessments',
  'side-automation': '/automation',
  'side-elementary-assessments': '/assessments',
  'side-badges': '/badges',
  'side-careers': '/careers',
  'side-elementary-careers': '/el/student/clusters',
  'side-elementary-career-matcher': '/el/student/career-quiz',
  'side-college-apps-settings': '/college-app-config',
  'side-college-cost': '/college-costs',
  'side-college-rep-events': '/college-events',
  'side-community-dashboard': '/industry-partner-dashboard',
  'side-community-user-management': '/community-user-management',
  'side-course-catalog': '/course-planner-setup',
  'side-course-planner': '/course-plans',
  'side-public-course-catalog': getPublicCourseCatalogURL(),
  'side-dashboard': '/dashboard',
  'side-data-upload': '/data-upload/overview',
  'side-district-connections': '/district-connections',
  'side-district-settings': '/district-settings/',
  'side-elementary-experience-tracking': '/el/experience-tracking',
  'side-employer-showcase': '/employer-showcase',
  'side-event-scheduler': '/event-scheduler',
  'side-final-list': '/schools/final-list',
  'side-college-admission-stats': '/schools/admission-stats',
  'side-financial-aid': '/financial-aid',
  'side-survey-bank': '/survey-bank-management',
  'side-game-of-life': '/game-of-life',
  'side-goals': '/goals/me',
  'side-homepage': '/login',
  'side-indicator-accountability-setup': '/scope-and-sequence-setup',
  'side-industry-partner-crm': '/industry-partner-database/contacts',
  'side-elementary-industry-partner-crm':
    '/el/industry-partner-database/contacts',
  'side-industry-partner-programs': '/program-management/programs',
  'side-key-readiness-indicators': '/key-readiness-indicators',
  'side-learning': '/learning',
  'side-elementary-learning': '/el/learning',
  'side-member-he-school-profile': '/profile-management',
  'side-member-management': '/community-user-management',
  'side-member-organization-profile': '/organization-profile',
  'side-method-test-prep-login': methodTestPrepLoginURL,
  'side-my-placements-candidate': '/program-exploration/candidate/placements',
  'side-k12-admin-meeting-scheduler': '/meetings',
  'side-k12-admin-ncaa': '/college-athletic-eligibility/tabular-view',
  'side-opportunities': '/opportunities',
  'side-opportunity-management': '/opportunity-management',
  'side-partner-directory': '/industry-partners',
  'side-personalized-plans': '/personalized-plans', // None student
  'side-elementary-personalized-plans': '/el/personalized-plans',
  'side-placement-history': '/program-management/placement-history',
  'side-program-exploration-candidate':
    '/program-exploration/candidate/all-programs',
  'side-program-exploration-staff': '/program-exploration',
  'side-student-profile': '/profile/edit',
  'side-elementary-virtual-workplace-tours': EL_VIRTUAL_TOURS,
  'side-virtual-workplace-tours': VIRTUAL_TOURS,
  'side-program-exploration-sponsor':
    '/program-exploration/sponsor/all-programs',
  'side-program-management': '/program-management/programs',
  'side-org-program-management': '/program-management',
  'side-district-pathways': '/student-pathways',
  'side-recommendation-letter-portal': '/recommendation-letter-portal',
  'side-recommendation-letter-requests': '/letters-of-recommendation',
  'side-report-center': '/report-center',
  'side-elementary-report-center': '/el/report-center',
  'side-roster-management': '/rosters/student-tags',
  'side-roster-management-elementary': '/el/rosters/staff-rosters',
  'side-scholarship-management': '/scholarship-management',
  'side-scholarship-matching': '/scholarship-matching',
  'side-school-events': '/dashboard/student/school-events',
  'side-school-favorites': '/schools/favorites',
  'side-school-search': '/schools/search',
  'side-student-accountability-tracker': '/accountability-tracker',
  'side-student-key-readiness-indicators': '/key-readiness-indicators',
  'side-student-list': '/student-list',
  'side-student-list-elementary': '/el/student-list',
  'side-student-personalized-plan': '/plans/overview',
  'side-washington-graduation-pathway': '/plans/washington-graduation-pathway',
  'side-student-transcript-request': '/record-requests/transcript',
  'side-survey-analytics': '/survey-analytics',
  'side-elementary-survey-analytics': '/el/survey-analytics',
  'side-senior-survey-analytics': '/senior-survey-analytics',
  'side-test-scores': '/test-scores',
  'side-transcript-center': '/record-requests',
  'side-transcript-management': '/record-requests/schools',
  'side-transcript-request': '/record-requests/requests',
  'side-upcoming-events': '/events/event-schedule',
  'side-experience-tracking': '/experience-tracking',
  'side-experience-tracking-supervisor': '/student-experience-supervision',
  'side-college-financing': '/award-letter-verification',
  'side-fafsa-tracker': '/fafsa-tracker',
  'side-indicator-verification':
    '/scope-and-sequence-verification/file-and-forms',
  'ohio-graduation-requirements':
    '/initiative-page/ohio-graduation-requirements',
  'dodea-transcript-template': '/initiative-page/dodea-transcript-template',
  'texas-semiconductor-manufacturing-careers':
    '/initiative-page/texas-semiconductor-manufacturing-careers',
  'side-elementary-dashboard': '/el/dashboard',
  'side-student-casefiles': '/el/casefile/',
  'side-checkins-overview': '/el/checkins/overview',
  'side-checkins-schedule': '/el/checkins/schedule',
  'side-checkins-insights': '/el/checkins/insights',
  'side-checkins-settings': '/el/checkins/settings',
  'side-checkins-suggested-lessons': '/el/checkins/suggested-lessons/redirect',
  'side-lesson-library': '/lesson-library/redirect',
  'side-career-interest': '/el/career-interest-analytics',
  'side-secondary-checkins-overview': '/checkins/overview',
  'side-secondary-checkins-schedule': '/checkins/schedule',
  'side-secondary-checkins-insights': '/checkins/insights',
  'side-secondary-checkins-settings': '/checkins/settings',
  'side-accountability-tracking-config':
    '/key-readiness-indicators/configuration/',
  'side-cte-status-dashboard': '/cte-status-dashboard',
  'side-credential-wallet': '/credential-wallet',
  'side-student-questions': '/mentor-videos',
};

export const NAV_MENU_ICON_PROPS = {
  size: 'lg',
  color: 'default',
};

export const APP_BAR_ITEM_ORDER = [
  'app-bar-back-button',
  'app-bar-schoolinks',
  'app-bar-google-translate',
  'app-bar-google-translate-elementary',
  'app-bar-demo-student-button',
  'app-bar-speaker',
  'app-bar-edit-profile-avatar',
  'app-bar-k12-admin-dashboard-switcher',
  'app-bar-credential-wallet',
  'app-bar-documents',
  'app-bar-message',
  'app-bar-notification',
  'app-bar-welcome-widget',
  'app-bar-settings',
  'app-bar-logout',
  'app-bar-avatar',
  'app-bar-member',
];

// `/org/{orgId}/` will be added to the beginning of the routes associated with these keys if an orgUuid is provided from user-context
export const ORG_SIDE_NAV_KEYS = [
  'side-scholarship-management',
  'side-opportunity-management',
  'side-member-organization-profile',
  'side-member-management',
  'side-member-he-school-profile',
  'side-event-scheduler',
  'side-org-program-management',
  'side-industry-partner-crm',
];
